module.exports = __webpack_public_path__ + "static/pokoj-nr1-photo06-nikon-541a5bed9d09f9de0b7b9b344e913955.jpg";